export interface AccessibilityStatement {
  status: "draft" | "published" | "in_progress";
  id: string;
  url: string;
  preview: string;
  edit_url: string;
  date: string;
  basicInfo: {
    companyName: string;
    websiteUrl: string;
    websiteName: string;
    publicationDate: string;
  };
  efforts: {
    selectedEfforts: string[];
    additionalEfforts: string[];
  };
  conformanceStatus: {
    standard: string;
    customStandard: string;
    conformanceLevel: string;
    additionalConsiderations: string;
    knownIssues: Array<{
      title: string;
      description: string;
    }>;
    unresolvedBarriers: string;
    contentOutsideScope: string;
  };
  technicalSpecs: {
    knownCompatibilities: {
      browsers: string[];
      operatingSystems: string[];
      assistiveTechnologies: string[];
    };
    knownIncompatibilities: {
      browsers: string[];
      operatingSystems: string[];
      assistiveTechnologies: string[];
    };
    technologyReliance: {
      selected: string[];
      other?: string;
    };
    assessmentApproach: {
      selected: string[];
      otherMethods: string[];
    };
  };
  feedback: {
    companyPhoneNumber: string;
    companyEmailAddress: string;
    companyVisitorAddress: string;
    companyPostalAddress: string;
    sameAsVisitorAddress: boolean;
    otherContactOptions: string;
    typicalDurationForResponse: string;
    enforcementTeam: {
      name: string;
      linkToEnforcementProcedure: string;
      contactDetails: string;
    }[];
  };
  relatedEvidence: {
    recentEvaluationReport: string;
    evaluationStatement: string;
    otherEvidence: string[];
  };
}

export const defaultStatement: AccessibilityStatement = {
  status: "draft",
  id: "",
  url: "",
  preview: "",
  edit_url: "",
  date: "",
  basicInfo: {
    companyName: "",
    websiteUrl: "",
    websiteName: "",
    publicationDate: new Date().toISOString().split("T")[0],
  },
  efforts: {
    selectedEfforts: [],
    additionalEfforts: [""],
  },
  conformanceStatus: {
    standard: "wcag21-aa",
    customStandard: "",
    conformanceLevel: "",
    additionalConsiderations: "",
    knownIssues: [{ title: "", description: "" }],
    unresolvedBarriers: "",
    contentOutsideScope: "",
  },
  technicalSpecs: {
    knownCompatibilities: {
      browsers: [""],
      operatingSystems: [""],
      assistiveTechnologies: [""],
    },
    knownIncompatibilities: {
      browsers: [""],
      operatingSystems: [""],
      assistiveTechnologies: [""],
    },
    technologyReliance: {
      selected: [],
      other: "",
    },
    assessmentApproach: {
      selected: [],
      otherMethods: [""],
    },
  },
  feedback: {
    companyPhoneNumber: "",
    companyEmailAddress: "",
    companyVisitorAddress: "",
    companyPostalAddress: "",
    sameAsVisitorAddress: false,
    otherContactOptions: "",
    typicalDurationForResponse: "",
    enforcementTeam: [
      {
        name: "",
        linkToEnforcementProcedure: "",
        contactDetails: "",
      },
    ],
  },
  relatedEvidence: {
    recentEvaluationReport: "",
    evaluationStatement: "",
    otherEvidence: [""],
  },
};
